import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { useParams } from "react-router-dom";
import t from "./common/localization";
import userAttributes from "./attributes/userAttributes";
import EditItemView from "./EditItemView";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Typography,
  FormControlLabel,
  Checkbox,
  Disabled,
  Paper,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditAttributesView from "./attributes/EditAttributesView";
import LinkField from "./form/LinkFieldAutoComplete";
import { prefixString } from "./common/stringUtils";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import SelectField from "./form/SelectField";
import { deviceCategories } from "./common/deviceCategories";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import Input from "@material-ui/core/Input";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  DatePicker,
  DateTimePicker,
} from "@material-ui/pickers";
import moment from "moment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

const mapLayer = [
  {
    value: "googleRoadmap",
    label: "Google Roadmap",
  },
  {
    value: "googleSatellite",
    label: "Google Satellite",
  },
  {
    value: "googleTerrain",
    label: "Google Terrain",
  },
  {
    value: "cartoBasemaps",
    label: "Carto Basemaps ",
  },
  {
    value: "openStreetmap",
    label: "Open Streetmap",
  },
  {
    value: "bingMaps",
    label: "Bing Maps",
  },
];
const coordinatesFormat = [
  {
    value: "dd",
    label: "Degrees Decimal",
  },
  {
    value: "ddm",
    label: " Degrees Decimal Minutes",
  },
  {
    value: "dms",
    label: "Degrees Decimal Seconds",
  },
];
const useStyles = makeStyles(() => ({
  details: {
    flexDirection: "row",
  },
  textField: {
    margin: "4px",
    width: "85%",
  },
  selectField: {
    width: "85%",
  },
  root: {
    padding: "10px",
    margin: "10px",
    marginLeft: "60px",
  },
  accordion: {
    marginTop: "10px",
  },
  multiSelectSelectedColor: {
    backgroundColor: "green",
  },
  input: {
    disableUnderline: true,
    style: {
      //underline:'false',
      backgroundColor: "#EFF2F8",
      borderRadius: "5px",
      border: "1px solid #6269C2",
      paddingLeft: "15px",
    },
  },
  menuItemCss: {
    "&.Mui-selected": {
      background: "#361DDB",
      color: "white",
    },
    "&:hover": {
      background: "#b3aeae",
      color: "black",
    },
    "&:hover.Mui-selected": {
      background: "#361DDB",
      color: "white",
    },
  },
}));

const UserPage = () => {
  const classes = useStyles();
  const operatingUser = useSelector((state) => state.session.user);
  const adminEnabled = operatingUser.administrator;
  const distributor = operatingUser.distributor;
  const prepaidUser = operatingUser.prepaid;
  const defaultDateTime = new Date(
    new Date().setFullYear(new Date().getFullYear() + 1)
  );
  const [item, setItem] = useState({ expirationTime: defaultDateTime });
  const expirationTime = item && item.expirationTime;

  const handleDateChange = (date) => {
    if (item.expirationTime) {
      const seconds = moment(item.expirationTime).seconds();
      const realDate = moment(date).set("seconds", seconds);
      // setSelectedDate(realDate);
      setItem({ ...item, expirationTime: realDate });
    } else {
      // setSelectedDate(date);
      setItem({ ...item, expirationTime: date });
    }
  };

  useEffect(() => {
    if (item && !expirationTime) {
      setItem({ ...item, expirationTime: defaultDateTime });
    }
  }, [expirationTime]);

  const [values, setValues] = React.useState({
    amount: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
  });
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    setItem({
      ...item,
      password: event.target.value,
    })
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <EditItemView
      endpoint="users"
      operatingUser={operatingUser}
      item={item}
      setItem={setItem}
    >
      {item && (
        <>
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={8}>
                <Paper elevation={3}>
                  <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1">
                        {t("sharedUserDetails")}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container spacing={3}>
                        <Grid item xs={6}>
                          <TextField
                            required={true}
                            className={classes.textField}
                            inputProps={{
                              style: { textTransform: "capitalize" },
                            }}
                            InputProps={{ disableUnderline: true }}
                            margin="normal"
                            value={item.name || ""}
                            onChange={(event) =>
                              setItem({ ...item, name: event.target.value })
                            }
                            label={t("userName")}
                            variant="standard"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            type="number"
                            className={classes.textField}
                            InputProps={{ disableUnderline: true }}
                            margin="normal"
                            value={item.phone || ""}
                            onChange={(event) =>
                              setItem({ ...item, phone: event.target.value })
                            }
                            label={t("userPhone")}
                            variant="standard"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <form noValidate>
                            <TextField
                              required={true}
                              className={classes.textField}
                              inputProps={{
                                style: { textTransform: "lowercase" },
                              }}
                              InputProps={{ disableUnderline: true }}
                              value={item.username || ""}
                              onChange={(event) =>
                                setItem({
                                  ...item,
                                  username: event.target.value,
                                })
                              }
                              label={t("username")}
                              variant="standard"
                            />
                          </form>
                        </Grid>

                        <Grid item xs={6}>
                          <FormControl className={classes.textField}>
                            <InputLabel>Password</InputLabel>
                            <Input
                              id="standard-adornment-password"
                              disableUnderline="true"
                              type={values.showPassword ? "text" : "password"}
                              value={item.password}
                              onChange={handleChange("password")}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {values.showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Paper>

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper elevation={3}>
                      <Accordion className={classes.accordion}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="subtitle1">
                            {t("sharedPreferences")}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                          <Grid container spacing={3}>
                            <Grid item xs={6}>
                              <TextField
                                className={classes.textField}
                                inputProps={{
                                  style: { textTransform: "lowercase" },
                                }}
                                InputProps={{ disableUnderline: true }}
                                margin="normal"
                                value={item.email || ""}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    email: event.target.value,
                                  })
                                }
                                label={t("userEmail")}
                                variant="standard"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                className={classes.textField}
                                InputProps={{ disableUnderline: true }}
                                id="outlined-select-mapLayer"
                                select
                                label="Map Layer"
                                value={item.mapLayer || "googleRoadmap"}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    mapLayer: event.target.value,
                                  })
                                }
                                variant="standard"
                                margin="normal"
                              >
                                {mapLayer.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                    className={classes.menuItemCss}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                className={classes.textField}
                                InputProps={{ disableUnderline: true }}
                                id="outlined-select-coordinateFormat"
                                select
                                label="Coordinates Format"
                                value={item.coordinateFormat || "dd"}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    coordinateFormat: event.target.value,
                                  })
                                }
                                variant="standard"
                              >
                                {coordinatesFormat.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                    className={classes.menuItemCss}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                className={classes.textField}
                                InputProps={{ disableUnderline: true }}
                                value={item.poiLayer || ""}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    poiLayer: event.target.value,
                                  })
                                }
                                label="POI Layer"
                                variant="standard"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                type="number"
                                className={classes.textField}
                                InputProps={{ disableUnderline: true }}
                                value={item.latitude || ""}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    latitude: event.target.value,
                                  })
                                }
                                label="Latitude"
                                variant="standard"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                type="number"
                                className={classes.textField}
                                InputProps={{ disableUnderline: true }}
                                value={item.longitude || ""}
                                onChange={(event) =>
                                  setItem({
                                    ...item,
                                    longitude: event.target.value,
                                  })
                                }
                                label="Longitude"
                                variant="standard"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                type="number"
                                className={classes.textField}
                                InputProps={{ disableUnderline: true }}
                                value={item.zoom || "15"}
                                onChange={(event) =>
                                  setItem({ ...item, zoom: event.target.value })
                                }
                                label="Map Zoom"
                                variant="standard"
                              />
                            </Grid>
                            {(adminEnabled || !prepaidUser) && (
                              <Grid item xs={6}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <DatePicker
                                    disableToolbar
                                    variant="standard"
                                    InputProps={{ disableUnderline: true }}
                                    format="dd/MM/yyyy"
                                    id="date-picker-inline"
                                    label="Account Expiry Date"
                                    value={item.expirationTime}
                                    // onChange={(event) =>
                                    //   setItem({ ...item, contact: event.target.value })
                                    // }
                                    onChange={handleDateChange}
                                    KeyboardButtonProps={{
                                      "aria-label": "change date",
                                    }}
                                  />
                                </MuiPickersUtilsProvider>
                              </Grid>
                            )}
                            {(adminEnabled || distributor) && (
                              <>
                                <Grid item xs={6}>
                                  <TextField
                                    required={true}
                                    type="number"
                                    className={classes.textField}
                                    inputProps={{ min: 0, max: 10000000 }}
                                    InputProps={{ disableUnderline: true }}
                                    value={item.userLimit || "0"}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        userLimit: event.target.value,
                                      })
                                    }
                                    label="User Limit"
                                    variant="standard"
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    required={true}
                                    type="number"
                                    className={classes.textField}
                                    inputProps={{ min: 0, max: 10000000 }}
                                    InputProps={{ disableUnderline: true }}
                                    value={item.deviceLimit || "0"}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        deviceLimit: event.target.value,
                                      })
                                    }
                                    label="Device Limit"
                                    variant="standard"
                                  />
                                </Grid>{" "}
                              </>
                            )}
                            <Grid item xs={3}>
                              <FormControlLabel
                                value="12-Hour Format"
                                control={
                                  <Checkbox
                                    checked={item.twelveHourFormat}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        twelveHourFormat: event.target.checked,
                                      })
                                    }
                                    color="primary"
                                  />
                                }
                                label="12-Hour Format"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <FormControlLabel
                                value="disabled"
                                control={
                                  <Checkbox
                                    checked={item.disabled}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        disabled: event.target.checked,
                                      })
                                    }
                                    color="primary"
                                  />
                                }
                                label="Disabled"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <FormControlLabel
                                value="readonly"
                                control={
                                  <Checkbox
                                    checked={item.readOnly}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        readOnly: event.target.checked,
                                      })
                                    }
                                    color="primary"
                                  />
                                }
                                label="Readonly"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <FormControlLabel
                                //  value="deviceReadonly"
                                control={
                                  <Checkbox
                                    // defaultChecked={item.deviceReadonly}
                                    checked={item.deviceReadonly || false}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        deviceReadonly: event.target.checked,
                                      })
                                    }
                                    color="primary"
                                  />
                                }
                                label="Device-Readonly"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={item.limitCommands || false}
                                    onChange={(event) =>
                                      setItem({
                                        ...item,
                                        limitCommands: event.target.checked,
                                      })
                                    }
                                    color="primary"
                                  />
                                }
                                label="Limit-Commands"
                                labelPlacement="start"
                              />
                            </Grid>
                            {adminEnabled && (
                              <Grid item xs={3}>
                                <FormControlLabel
                                  value="distributor"
                                  control={
                                    <Checkbox
                                      checked={item.distributor}
                                      onChange={(event) =>
                                        setItem({
                                          ...item,
                                          distributor: event.target.checked,
                                        })
                                      }
                                      color="primary"
                                    />
                                  }
                                  label="Distributor"
                                  labelPlacement="start"
                                />
                              </Grid>
                            )}

                            {adminEnabled && (
                              <Grid item xs={3}>
                                <FormControlLabel
                                  value="prepaid"
                                  control={
                                    <Checkbox
                                      checked={item.prepaid}
                                      onChange={(event) =>
                                        setItem({
                                          ...item,
                                          prepaid: event.target.checked,
                                        })
                                      }
                                      color="primary"
                                    />
                                  }
                                  label="Prepaid"
                                  labelPlacement="start"
                                />
                              </Grid>
                            )}
                            {adminEnabled && (
                              <Grid item xs={3}>
                                <FormControlLabel
                                  disableRipple
                                  value="administrator"
                                  control={
                                    <Checkbox
                                      checked={item.administrator}
                                      onChange={(event) =>
                                        setItem({
                                          ...item,
                                          administrator: event.target.checked,
                                        })
                                      }
                                      color="primary"
                                    />
                                  }
                                  label="Admin"
                                  labelPlacement="start"
                                />
                              </Grid>
                            )}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Paper>
                  </Grid>
                </Grid>
                {item.id && (
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Paper elevation={3}>
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="subtitle1">
                              {t("sharedConnections")}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className={classes.details}>
                            <Grid container spacing={3}>
                              <Grid item xs={6}>
                                <FormControl className={classes.selectField}>
                                  <LinkField
                                    endpointAll="/api/devices?all=true"
                                    endpointLinked={
                                      "/api/devices?userId=" + item.id
                                    }
                                    baseId={item.id}
                                    keyBase="userId"
                                    keyLink="deviceId"
                                    label={t("deviceTitle")}
                                    variant="standard"
                                  />
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <FormControl className={classes.selectField}>
                                  <LinkField
                                    endpointAll="/api/groups?all=true"
                                    endpointLinked={
                                      "/api/groups?userId=" + item.id
                                    }
                                    baseId={item.id}
                                    keyBase="userId"
                                    keyLink="groupId"
                                    label={t("settingsGroups")}
                                    variant="standard"
                                  />
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <FormControl className={classes.selectField}>
                                  <LinkField
                                    endpointAll="/api/geofences"
                                    endpointLinked={
                                      "/api/geofences?userId=" + item.id
                                    }
                                    baseId={item.id}
                                    keyBase="userId"
                                    keyLink="geofenceId"
                                    label={t("sharedGeofences")}
                                    variant="standard"
                                  />
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <FormControl className={classes.selectField}>
                                  <LinkField
                                    endpointAll="/api/notifications"
                                    endpointLinked={
                                      "/api/notifications?userId=" + item.id
                                    }
                                    baseId={item.id}
                                    keyBase="userId"
                                    keyLink="notificationId"
                                    titleGetter={(it) =>
                                      t(prefixString("event", it.type))
                                    }
                                    label={t("sharedNotifications")}
                                    variant="standard"
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </Paper>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid item xs={4}>
                <Paper elevation={3}>
                  <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1">
                        {t("sharedAttributes")}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <EditAttributesView
                        attributes={item.attributes}
                        setAttributes={(attributes) =>
                          setItem({ ...item, attributes })
                        }
                        definitions={userAttributes}
                      />
                    </AccordionDetails>
                  </Accordion>
                </Paper>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </EditItemView>
  );
};
export default UserPage;
